import { useMemo } from 'react';

const usePartnerhubIntegrationDetection = () => {
  const searchParams = useMemo(() => new URLSearchParams(location.search), []);

  const isPartnerhubRedirection = searchParams.get('partnerhubredirection') === 'true';
  const isActivateStats = searchParams.get('activatestats') === 'true';

  return {
    isPartnerhubRedirection,
    isActivateStats,
    isPartnerhubWithActivateStats: isPartnerhubRedirection && isActivateStats,
  };
};

export default usePartnerhubIntegrationDetection;
